import { ModalBody } from '@chakra-ui/react'
import { Fragment, useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ControlledStepper } from '../../../../../components/ControlledStepper'
import { StepCreateNamespace } from '../steps/StepCreateNamespace'
import { StepCreateAndAssignUser } from '../steps/StepCreateAndAssignUser'


interface DefaultFlowProps {
  close: () => void
}

export function DefaultFlow({ close }: DefaultFlowProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'namespaces.create' })

  const [ step, setStep ] = useState(1)
  const [ namespaceId, setNamespaceId ] = useState<string>()

  const steps = useMemo(() => [
    { title: t('steps.create_namespace.title') },
    { title: t('steps.create_assign_user.title') }
  ], [ t ])

  const goToStepTwo = useCallback((namespaceId: string) => {
    setNamespaceId(namespaceId)
    setStep(2)
  }, [])

  return (
    <Fragment>
      <ModalBody marginY={4}>
        <ControlledStepper steps={steps} activeStep={step - 1} />
      </ModalBody>

      {step === 1 && (
        <StepCreateNamespace
          next={goToStepTwo}
          close={close}
        />
      )}

      {step === 2 && namespaceId && (
        <StepCreateAndAssignUser
          namespaceId={namespaceId}
          close={close}
        />
      )}

    </Fragment>
  )
}
